function Momentum() {
	this.build();
}

Momentum.prototype.build = function () {
	document.querySelectorAll('[data-y]').forEach(function (element) {
		let yValue = -50;
		let momentumValue = 1.5;

		if ($(element).data('y')) {
			yValue = $(element).data('y');
		}

		if ($(element).data('momentum')) {
			momentumValue = $(element).data('momentum');
		}

		gsap.to($(element), {
			scrollTrigger: {
				trigger: $(element),
				start: 'top bottom',
				end: 'bottom top',
				scrub: momentumValue
			},
			y: yValue,
			ease: "none"
		});
	});
};